import React from 'react'
import { useHistory, Link } from 'react-router-dom'
import logo from '../../assets/images/logo_2.png'
import qoute from '../../assets/images/quote2.png'
import truck from '../../assets/images/truck.png'

function SignUp() {
    const history = useHistory()
    return (
        <div className='sign-parent'>
            <div className='sign-logo'>
                <img src={logo} alt="" />
            </div>
            <div className='sign-cont'>
                <div className='sign-truck'>
                    <img src={truck} alt="" />
                </div>
                <div className='sign-form'>
                    <form>
                        <div className=' load-form'>
                            <h3>Sign Up</h3>
                            <p>Lorem Ipsum is simply text</p>
                            <div className=' load-input-wrapper'>
                                <div className=' load-input'>
                                    <label>Full Name</label>
                                    <input required type={'text'} placeholder="Enter full name" className='form-input_ input' />
                                </div>
                                <div className=' load-input'>
                                    <label>Email</label>
                                    <input required type={'email'} placeholder="Enter email" className='form-input_ input' />
                                </div>
                                <div className='sign-pass-cont'>
                                    <div className=' load-input'>
                                        <label>Password</label>
                                        <input required type={'password'} placeholder="Enter password" className='form-input_' />
                                    </div>
                                    <div className='sign-pass-cont-sep'></div>
                                    <div className=' load-input'>
                                        <label>Confirm Password</label>
                                        <input required type={'password'} placeholder="Enter confirm password" className='form-input_' />
                                    </div>
                                </div>
                            </div>
                            <div className='form-buttons'>
                                <button onClick={() => history.push('/sign-in')} style={{ fontSize: '14px' }} className='button-primary'>Sign Up</button>
                            </div>
                            <div className='sign-form-bottom'>
                                <p>Already have an account? <Link to="/sign-in">Login</Link></p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div className='sign-footer'>
                <img src={qoute} alt="" />
            </div>
        </div>
    )
}

export default SignUp